<template>
  <v-card color="neutral800" class="pos-r" flat>
    <v-window v-model="currentPage">
      <v-window-item :value="0">
        <v-card-text class="px-10">
          <v-row>
            <v-col>
              <v-card class="b-rad-24 overflow-hidden">
                <div class="flex-center elevation-10">
                  <label
                    @dragover.prevent
                    @dragenter="isGrabing = true"
                    @drop.prevent="handleDrop"
                    @dragend="isGrabing = false"
                    @dragleave="isGrabing = false"
                    @click="(e) => !!hasCover && e.preventDefault()"
                    class="cursor-pointer w100p pos-r overflow-hidden"
                  >
                    <v-img
                      :aspect-ratio="480 / 211"
                      class="b-rad-6 elevation-10 pa-8"
                      :src="
                        (expoData.image && expoData.image.url) ||
                        previewImg ||
                        null
                      "
                      cover
                    >
                      <div
                        class="file_area fill-all flex-center"
                        :class="{ isGrabing, isError: !!fileEmptyError }"
                        v-if="!hasCover"
                      >
                        <div class="fill-all flex-center flex-column">
                          <v-icon size="120">mdi-image-area</v-icon>
                          <span class="text-h6">
                            {{ $t('SPACE.WORD.NO_COVER') }}
                          </span>
                        </div>
                      </div>
                    </v-img>
                    <div
                      v-if="isUploadingImage"
                      class="fill-all flex-center neutral300 opacity--70 pos-a tl0"
                    >
                      <v-progress-circular
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </div>
                    <v-chip
                      color="neutral400"
                      class="change_cover_label b-rad-3 px-2"
                      @click.stop
                      :ripple="false"
                      tag="label"
                      label
                    >
                      <v-icon class="mr-2">mdi-camera-enhance</v-icon>
                      {{ $t('SPACE.WORD.CHANGE_COVER') }}
                      <input
                        ref="fileInput"
                        @change="handleFileChange"
                        type="file"
                        hidden
                        accept=".jpg,.jpeg,.png"
                      />
                    </v-chip>
                  </label>
                </div>
                <v-card-text class="px-8 pb-1">
                  <div class="d-flex align-center">
                    <span class="text-truncate neutral100--text title">
                      {{ $t('SPACE.WORD.SPACE_NAME') }}
                    </span>
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      small
                      class="px-0"
                      @click="isEditDialogOpen = true"
                    >
                      <v-icon color="" size="18" class="mr-1">
                        mdi-pencil
                      </v-icon>
                      {{ $t('COMMON.WORD.EDIT') }}
                    </v-btn>
                  </div>
                </v-card-text>
                <div class="text-h5 neutral100--text px-8 line-clamp-2">
                  {{ expoData.name }}
                </div>
                <SizeBox height="36" />
                <div class="expo_desception px-8 pb-4">
                  <div
                    v-if="!expoData.description"
                    class="flex-center flex-column text-center text-pre-wrap"
                  >
                    尚未輸入展覽描述
                    <br />
                    {{ $t('SPACE.COPYWRITING.DESCRIPTION_IMPROVE_SEO') }}
                  </div>
                  <div v-else class="text-pre-wrap">
                    <span class="text-truncate neutral100--text title">
                      {{ $t('SPACE.WORD.EXHIBITION_DESCRIPTION') }}
                    </span>
                    <div class="line-clamp-4">
                      {{ expoData.description }}
                    </div>
                  </div>
                </div>
              </v-card>
            </v-col>

            <v-col>
              <v-card class="b-rad-24 overflow-hidden">
                <v-card-title>作品管理</v-card-title>
                <v-card-text>
                  <Async class="flex-center" :loading="isFetching">
                    <div class="mw24p">
                      <p
                        v-if="expoData.assets.length"
                        class="text-center neutral100--text"
                      >
                        <span class="text-h2 font-weight-bold">
                          {{ expoData.assets.length }}
                        </span>
                        <br />
                        <span class="">已上傳作品</span>
                      </p>

                      <v-img
                        v-else
                        :src="require(`@/assets/images/upload_cloud.svg`)"
                      ></v-img>
                    </div>
                  </Async>
                  <SizeBox height="16" />
                  <div v-if="!expoData.assets.length" class="text-center">
                    快來布置你專屬的線上展場！
                  </div>
                  <SizeBox height="18" />
                  <div class="flex-center">
                    <v-btn
                      color="primary"
                      rounded
                      class="w80p"
                      @click="currentPage = 1"
                    >
                      {{
                        expoData.assets.length
                          ? '上傳 / 編輯作品'
                          : '開始上傳作品'
                      }}
                    </v-btn>
                  </div>
                </v-card-text>
                <SizeBox height="24" />
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-window-item>
      <v-window-item :value="1">
        <Map v-if="expoData.id" :expo-data="expoData" @back="currentPage = 0" />
      </v-window-item>
    </v-window>

    <v-dialog
      v-model="isEditDialogOpen"
      transition="dialog-transition"
      max-width="800"
    >
      <v-card class="overflow-hidden" color="neutral500">
        <SizeBox height="8" />
        <div class="d-flex justify-end">
          <v-avatar
            size="24"
            @click="isEditDialogOpen = false"
            class="cursor-pointer"
          >
            <img :src="require(`@/assets/icons/close.svg`)" />
          </v-avatar>
          <SizeBox width="8" />
        </div>
        <v-card-title class="flex-center">
          {{ $t('SPACE.WORD.SPACE_INFO') }}
        </v-card-title>
        <SizeBox height="8" />

        <v-card-text class="px-16">
          <v-form ref="form">
            <div class="mb-2">
              <span class="mr-1 error--text text-body-1">*</span>
              <span class="neutral100--text text-body-1">
                {{ $t('SPACE.WORD.SPACE_NAME') }}
              </span>
            </div>
            <v-text-field
              counter="30"
              v-model="form.name"
              :rules="[
                (v) => $rules.required(v),
                (v) => $rules.maxLength(v, 30)
              ]"
              outlined
              background-color="neutral700"
            ></v-text-field>

            <SizeBox height="36" />
            <div class="mb-2">
              <span class="neutral100--text text-body-1">
                {{ $t('SPACE.WORD.EXHIBITION_DESCRIPTION') }}
              </span>
              <span class="ml-2 text-body-2">
                {{ $t('SPACE.COPYWRITING.IMPROVE_SEO') }}
              </span>
            </div>
            <v-textarea
              v-model="form.description"
              :placeholder="$t('SPACE.COPYWRITING.ENTER_DESCRIPTION')"
              rows="5"
              counter
              outlined
              background-color="neutral700"
            >
              <template #counter="{ props }">
                <span class="neutral100--text">
                  <!-- 已輸入 {{ props.value }} 字 (建議 46 字內) -->
                  {{ $t('SPACE.EDIT.INPUT.REMIND.ENTER_TOTAL') }}
                  {{ props.value }} {{ $t('COMMON.WORD.WORD')
                  }}{{
                    $t('SPACE.EDIT.INPUT.REMIND.RECOMMEND_WITHIN_46_WORDS')
                  }}
                </span>
              </template>
            </v-textarea>
          </v-form>
        </v-card-text>

        <v-card-actions class="flex-center">
          <v-btn
            width="120"
            height="41"
            outlined
            @click="isEditDialogOpen = false"
          >
            {{ $t('COMMON.WORD.CANCEL') }}
          </v-btn>
          <v-btn
            width="120"
            height="41"
            color="primary"
            depressed
            @click="submit"
            :loading="isPatchingExpo"
          >
            {{ $t('COMMON.WORD.SAVE_CHANGES') }}
          </v-btn>
        </v-card-actions>
        <SizeBox height="24" />
      </v-card>
    </v-dialog>

    <ShareFrame v-model="isShowSharFrame" :expo-data="expoData" />
  </v-card>
</template>

<script>
import {
  getExhibitionByLang,
  publishExhibition,
  setExhibitionByLang
} from '@/api/panel/exhibitions';
import { addImageByCategory } from '@/api/panel/images';
4;

import Map from '@/components/exhibitions/_expoId/Map.vue';
import ShareFrame from '@/components/exhibitions/ShareFrame.vue';

export default {
  components: { Map, ShareFrame },
  data() {
    return {
      isGrabing: false,
      previewImg: null,
      fileEmptyError: null,
      isUploadingImage: false,
      isShowSharFrame: false,
      isChangingStatus: false,

      currentPage: 1,
      isEditDialogOpen: false,
      isPatchingExpo: false,
      form: {
        name: '',
        description: ''
      },
      lang: 'default',
      expoData: {
        id: null,
        alias: '',
        artworkType: '',
        assets: [],
        deletedStatus: '',
        description: '',
        image: {},
        name: '',
        scene: {},
        status: '',
        updatedAt: 0
      }
    };
  },

  computed: {
    hasCover() {
      return (
        (this.expoData.image && this.expoData.image.url) ||
        this.previewImg ||
        null
      );
    },
    isBanned() {
      return this.expoData.status === 'banned';
    }
  },

  watch: {
    isEditDialogOpen(v) {
      if (v) {
        this.form.name = this.expoData.name;
        this.form.description = this.expoData.description;
      }
    },
    currentPage(v) {
      if (v === 0 && this.$route.name !== 'exhibitions-edit') {
        this.$router.push({ name: 'exhibitions-edit' });
        this.fetchData();
      }
      if (v === 1 && this.$route.name !== 'exhibitions-map')
        this.$router.push({ name: 'exhibitions-map' });
    }
  },

  async created() {
    if (!this.$route.params.expoId)
      this.$router.replace({ name: 'exhibitions' });
    // if (this.$route.name === 'exhibitions-edit') this.currentPage = 0;
    // if (this.$route.name === 'exhibitions-map') this.currentPage = 1;

    this.fetchData();
  },
  methods: {
    parseStatus(status) {
      switch (status) {
        case 'published':
          return {
            text: this.$t('COMMON.WORD.PUBLISH'),
            icon: 'mdi-eye',
            color: 'primary'
          };
        case 'unpublished':
          return { text: '未公開', icon: 'mdi-eye-off', color: 'primary700' };
        case 'banned':
          return { text: '已上鎖', icon: 'mdi-lock-outline', color: 'error' };

        default:
          return { text: '未公開', icon: 'mdi-eye-off', color: 'primary700' };
      }
    },
    async fetchData() {
      this.isFetching = true;
      const lang = localStorage.getItem('language')
        ? localStorage.getItem('language').toLowerCase()
        : 'tw';
      const Expo = await getExhibitionByLang({
        id: this.$route.params.expoId,
        lang: this.lang
      });

      if (!Expo.error) {
        this.$set(this, 'expoData', Expo);
      } else {
        this.$router.replace({ name: 'exhibitions' });
      }
      this.isFetching = false;
    },
    handleDrop(e) {
      this.isGrabing = false;
      if (e.dataTransfer.files.length) {
        const file = e.dataTransfer.files[0];
        const exts = ['jpg', 'jpeg', 'png'];

        if (exts.includes(file.name.split('.').pop())) {
          this.handlePreview(file);
        } else {
          this.$toast.error('ARTWORK.EDIT.TOAST.ALERT.FILE_FORMAT_NOT_MATCH');
        }
      }
    },
    handleFileChange(e) {
      if (e.target.files.length) {
        const file = e.target.files[0];
        this.handlePreview(file);
      }
    },
    handlePreview(file) {
      if (file.size > 1048576 * 5) {
        this.$toast.error(
          `${this.$t('ARTWORK.EDIT.COPYWRITING.FILE_SIZE_NOT_EXCEED')} 5MB`
        );
        return;
      }
      this.isUploadingImage = true;
      this.holdingFile = file;
      const FR = new FileReader();
      FR.onload = (e) => {
        this.previewImg = FR.result;
        this.upload(file);
      };

      if (file) {
        FR.readAsDataURL(file);
      }
    },
    async upload(image) {
      this.isUploadingImage = true;

      const form = new FormData();
      form.append('file', image);
      const { id, url, error } = await addImageByCategory({
        category: 'exhibition',
        data: form
      });

      const Upload = await setExhibitionByLang({
        id: this.$route.params.expoId,
        teamImageId: id
      });

      if (!error && !Upload.error) {
        this.$toast(this.$t('ARTWORK.EDIT.TOAST.SUCCESS.UPLOAD_SUCCESSFUL'));
        this.$set(this.expoData, 'image', Upload.image);
      } else {
        this.$toast.error(this.$t('ARTWORK.EDIT.TOAST.ALERT.UPLOAD_FAILED'));
      }

      this.isUploadingImage = false;
    },

    goBack() {
      this.$router.push({ name: 'exhibitions' });
    },
    onCoverLoaded(v) {
      //
    },
    async beforeChangeStatus() {
      if (this.expoData.status === 'unpublished') {
        this.$store.dispatch('modal/ACTIVE_MODAL', {
          title: this.$t('SPACE.POPUP.COPYWRITING.CONFIRM_PUBLISH'),
          content:
            this.$t('SPACE.POPUP.COPYWRITING.AFTER_PUBLISHED') +
            '\n' +
            this.$t('SPACE.POPUP.COPYWRITING.ANYONE_CAN_VISIT'),
          action: {
            text: this.$t('COMMON.WORD.PUBLISH'),
            callback: this.toggleStatus
          },
          cancel: {
            text: this.$t('COMMON.WORD.CANCEL')
          }
        });
      } else {
        this.toggleStatus();
      }
    },
    async toggleStatus(expo = this.expoData) {
      let status = '';
      if (expo.status === 'published') status = 'unpublished';
      if (expo.status === 'unpublished') status = 'published';

      this.isChangingStatus = true;
      const Expo = await publishExhibition({
        id: expo.id,
        status
      });

      if (!Expo.error) {
        expo.status = Expo.status;
        this.$toast(
          `${this.$t('COMMON.WORD.EXHIBITION')}${this.$t(
            'COMMON.WORD.ALREADY'
          )} ${
            status === 'published'
              ? this.$t('COMMON.WORD.PUBLISH')
              : this.$t('COMMON.WORD.UNPUBLISH')
          }`
        );
        this.$store.dispatch('modal/CLOSE_MODAL');
      } else {
        !!Expo.error.message && this.$toast.error(Expo.error.message);
      }
      await this.fetchData();
      this.isChangingStatus = false;
    },

    async submit() {
      if (!this.$refs.form.validate()) return;
      this.isPatchingExpo = true;

      const Expo = await setExhibitionByLang({
        id: this.$route.params.expoId,
        lang: this.lang,
        name: this.form.name,
        description: this.form.description
      });

      if (!Expo.error) {
        this.$set(this.expoData, 'name', Expo.name);
        this.$set(this.expoData, 'description', Expo.description);
        this.$set(this.expoData, 'updatedAt', Expo.updatedAt);
        this.$toast(this.$t('SPACE.TOAST.SUCCESS.UPDATE_SUCCESS'));
        this.isEditDialogOpen = false;
      } else {
        this.$toast.error(this.$t('SPACE.TOAST.ALERT.UPDATE_FAILED'));
      }

      this.isPatchingExpo = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.center_info {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.status_display {
  font-size: 0.875rem;
}

.change_cover_label {
  position: absolute;
  left: 26px;
  bottom: 10px;
}

.file_area {
  * {
    user-select: none;
  }
  position: relative;
  border: 1px dashed;
  border-color: $neutral300;
  border-radius: 6px;
  background-color: $neutral700;

  &.isError {
    border-color: $error;
  }

  &.isGrabing {
    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      width: calc(100% - 8px);
      height: calc(100% - 8px);
      background-color: rgba($neutral100, $alpha: 0.6);
      border-radius: 6px;
      border: 2px solid $primary;
    }
  }
}

.bradcrumb_title {
  position: sticky;
}

.expo_desception {
  min-height: 180px;
}
</style>